import { render, staticRenderFns } from "./VerifyAddress.vue?vue&type=template&id=fdda5750&scoped=true&"
import script from "./VerifyAddress.vue?vue&type=script&lang=js&"
export * from "./VerifyAddress.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAddress.vue?vue&type=style&index=0&id=fdda5750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda5750",
  null
  
)

export default component.exports